











    import Component from 'vue-class-component'
    import {Prop, Watch, Vue, Emit} from 'vue-property-decorator'

    @Component({
        components: {}
    })
    
    class Scrollable extends Vue{
        scrolled: 0

        $refs:{
            content: HTMLElement, scroller: HTMLElement, wrapper: HTMLElement
        }
        handleScroller () {
                this.$refs.content.scrollLeft = this.$refs.scroller.scrollLeft;
        }
        handleContent () {
                this.$refs.scroller.scrollLeft = this.$refs.content.scrollLeft;
        }
        mounted () {
            Vue.nextTick(()=>{
                if (this.$refs.scroller)
                    this.$refs.scroller.addEventListener('scroll', this.handleScroller);
                const table = this.$children[0].$children[1].$children[0];

                if (table)
                    table.$el.addEventListener('scroll', this.handleContent);
                this.$refs.wrapper.style.display ="block";
                if (table.$el) this.$refs.scroller.style.width = table.$el.clientWidth +"px";

            });
//            if (this.$refs.scroller)
//            this.$refs.scroller.addEventListener('scroll', this.handleScroller);
//            if (this.$refs.content)
//            this.$refs.content.addEventListener('scroll', this.handleContent);
//            this.$refs.wrapper.style.display ="block";
//            if (this.$refs.content) this.$refs.wrapper.style.width = this.$refs.content.clientWidth +"px";
        }
        beforeDestroy () {
            this.$refs.scroller.removeEventListener('scroll', this.handleScroller);
            if (this.$refs.content) this.$refs.content.removeEventListener('scroll', this.handleContent);
        }
    }

    export default Scrollable;
